import { useEffect, useState } from 'react';

interface Props {
	threshold?: number
}

const useScrollToTop = ({ threshold = 200 }: Props) => {
	const [showScrollTop, setShowScrollTop] = useState(false)
	useEffect(() => {
		const handleScroll = () => {
			setShowScrollTop(window.scrollY > threshold)
		}

		window.addEventListener("scroll", handleScroll)
		return () => window.removeEventListener("scroll", handleScroll)
	}, [])

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" })
	}

	return { showScrollTop, scrollToTop }
};

export default useScrollToTop;
